import { useState, useEffect } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);

    // Set initial value
    setMatches(media.matches);

    // Create listener
    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Add listener
    media.addEventListener('change', listener);

    // Cleanup
    return () => {
      media.removeEventListener('change', listener);
    };
  }, [query]);

  return matches;
}

// Predefined breakpoints matching Tailwind CSS
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)'); // lg breakpoint
}

export function useIsTablet(): boolean {
  return useMediaQuery('(min-width: 768px)'); // md breakpoint
}

export function useIsMobile(): boolean {
  return !useMediaQuery('(min-width: 768px)');
}
